import { comparisonOptions, constructSingleMapParamSet } from 'shared/utilities/filterUtils'
import GenericFieldSet from 'AdvancedSearch/FilterComponent/FieldSet/GenericFieldSet'
import TextSelectField from 'AdvancedSearch/FilterComponent/Field/TextSelectField'

const TaxLien = () => ({
  summaryBackgroundColorClass: 'summary-blue',
  resourceConstant: 'TAX_LIEN',
  urlPath: 'taxliens',
  label: 'Tax Lien',
  sentenceNoun: 'tax liens',
  // Advanced-search results sentence: "...that have been on the tax lien sale list"
  // (supplies its own verb, so the default "have" lead is suppressed).
  boolSentence: {
    yes: 'have been on the tax lien sale list',
    no: 'have not been on the tax lien sale list',
  },
  ownResourceFilters: {
    initial: {
      generatorFunction: resourceModel => {
        return constructSingleMapParamSet({
          resourceModel,
          component: GenericFieldSet,
          baseComponent: TextSelectField,
          paramMapType: 'BOOL',
          paramMapRole: 'PRIMARY',
          valuePrefix: 'Is on tax lien sale list?',
          paramMapField: 'count',
          paramMapComparison: 'gte',
          paramMapValue: '1',
          paramNoun: 'tax liens',
          defaultOptions: comparisonOptions({
            name: 'value',
            comparisonValues: ['0', '1'],
            labels: ['No', 'Yes'],
          }),
        })
      },
    },
  },
})

export default TaxLien
